import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { type Pagination, toQuery } from "@/api/pagination";
import { client } from "../client";

export const useAdminUsers = (
  pagination: Pagination,
  sort: {
    column: "firstName" | "role" | "createdAt" | "lastActivity" | "tosDate" | undefined;
    direction: "asc" | "desc";
  },
  { merchantId, text }: { merchantId?: string; text?: string },
) => {
  return useQuery({
    queryKey: ["admin", "users", pagination.limit, pagination.offset, sort.column, sort.direction, text, merchantId],
    queryFn: async () => {
      const res = await client.admin.user.$get({ query: { ...toQuery(pagination), ...sort, text, merchantId } });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};
